<template>
   <span
     class="pointer"
     title="Перезвонить клиенту"
     :style="{
            opacity: (loading)?0.5:1
          }"
     @click="onChange"
   >
     <span><v-icon
       :style="{
            'font-size': (isOk===0)?'14px':'20px',
            color: (isOk===0)?'gray':'gold',
            'border-radius': '50%',
            'border': '1px solid',
            'background-color': (isOk===0)?'transparent':'white',
            'border-color': (isOk===0)?'transparent':'red',
            'margin': '2px',
            'padding': '2px',
          }"
     >mdi-bell-ring-outline</v-icon>
</span>
    </span>
</template>

<script>
export default {
  name: 'IsNeedCallback',
  props: {
    isOk: {
      type: Number,
      default: 0,
    },
    icon: {
      type: String,
      default: 'mdi-account',
    },
    updateRequest: {
      type: Function,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    onChange() {
      if (!this.disabled && !this.loading) {
        this.updateValue(1 - this.isOk);
      }
    },
    updateValue(value) {
      this.$emit('updated', value);
      if (this.updateRequest) {
        this.loading = true;
        setTimeout(() => {
          this.updateRequest(value)
            .catch(error => {
              this.$emit('updated', 1 - value);
              console.error(error);
            })
            .finally(() => {
              this.loading = false;
            });
        }, 0);
      }
    },
  },
};
</script>

<style scoped>
</style>
